import React, { useState } from "react";
import PresupuestoForm from "./PresupuestoForm";
import PresupuestoPDF from "./PresupuestoPDF";
import PresupuestoPDFDocument from "./PresupuestoPDFDocument";
import styled, { keyframes } from "styled-components";
import { pdf } from "@react-pdf/renderer";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { addDoc, collection } from "firebase/firestore";
import { storage, db } from "./Firebase";
import { RiArrowGoBackFill } from "react-icons/ri";

const Contenedor = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
`;
const ContenedorButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;
const AnimatedIcon = styled(RiArrowGoBackFill)`
  cursor: pointer;
  &:hover {
    animation: ${bounce} 1s ease infinite;
  }
`;

const PresupuestoApp = ({ isDarkMode }) => {
  const [presupuestoGenerado, setPresupuestoGenerado] = useState(null);

  const formulario = () => {
    setPresupuestoGenerado(null);
  };

  const generarPresupuesto = async (datos) => {
    // Generar PDF blob
    const blob = await pdf(<PresupuestoPDFDocument datos={datos} />).toBlob();

    // Subir a Firebase Storage
    const fileRef = ref(storage, `presupuestos/Presupuesto-${datos.docId}.pdf`);
    await uploadBytes(fileRef, blob);

    const downloadURL = await getDownloadURL(fileRef);

    // Enviar correo solo desde aquí
    if (datos.emailCliente && datos.emailCliente.includes("@")) {
      await addDoc(collection(db, "mail"), {
        to: datos.emailCliente,
        cc: [datos.correoEjecutivo, "rojas_dario@catainternacional.com"],
        from: `"CATA Internacional" <${datos.correoEjecutivo}>`, // 👈 este es el remitente visible
        replyTo: datos.correoEjecutivo, // 👈 opcional, para respuestas
        message: {
          subject: `Presupuesto - ${datos.empresa}`,
          html: `
            <p style="margin: 0px; font-weight: bold;">Estimado/a ${datos.nombre},</p>
            <br>
            <p style="margin: 0px;">Adjuntamos el presupuesto solicitado en el siguiente enlace:</p>
            <p style="margin: 0px;"><a href="${downloadURL}" target="_blank">Descargar PDF</a></p>
            <br>
            <p style="margin: 0px;">Atentamente,</p>
            <p style="margin: 0px;">${datos.nombreEjecutivo}</p>
            <p style="margin: 0px;">WhatsApp: ${datos.telefonoEjecutivo}</p>
            <br>
            <hr>
            <p style="margin: 0px; font-size: 12px; color: #555;">
              Este es un correo automático generado por el sistema de presupuestos de CATA Internacional.
            </p>
          `,
        },
      });
    }

    // Seteamos para mostrar PDF y descarga en pantalla
    setPresupuestoGenerado(datos);
  };

  return (
    <Contenedor>
      {presupuestoGenerado ? (
        <ContenedorButton>
          <PresupuestoPDF datos={presupuestoGenerado} isDarkMode={isDarkMode} />
          <AnimatedIcon onClick={formulario} size={30} />
          <p>Volver al formulario</p>
        </ContenedorButton>
      ) : (
        <PresupuestoForm generarPresupuesto={generarPresupuesto} />
      )}
    </Contenedor>
  );
};

export default PresupuestoApp;
